var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { sessionStorageKeys, SIGN_IN_HOST_PATH } from '../constants/general';
// Common Utilities
export var windowExists = function () { return typeof window !== 'undefined'; };
export var getPLCCAccrualData = function (perkData) {
    var _a;
    var responseData = perkData &&
        (perkData.accrualData || ((_a = perkData.rewardsandoffers) === null || _a === void 0 ? void 0 : _a.accrualData));
    var currentYear = new Date().getFullYear();
    return (responseData === null || responseData === void 0 ? void 0 : responseData.find(function (data) { return data.year === currentYear; })) || {};
};
export var THD_CUSTOMER = function () {
    var _a;
    return typeof window !== 'undefined'
        ? (_a = window === null || window === void 0 ? void 0 : window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default
        : { role: '', jwt: '' };
};
export var getUserRole = function () {
    var _a;
    return ((_a = THD_CUSTOMER()) === null || _a === void 0 ? void 0 : _a.role) || 'PURCHASER';
};
export var toStartCase = function (allCapsName) {
    return allCapsName
        .toLowerCase()
        .replace(/\b\w/g, function (char) { return char.toUpperCase(); });
};
export var floorNumberWithCommas = function (num, decimalPostion) {
    if (num === 0) {
        return '0';
    }
    if (!num || Number.isNaN(num)) {
        return '';
    }
    return Math.floor(Number(num))
        .toFixed(decimalPostion)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var gatherAllParamsToString = function (prefix) {
    var _a, _b;
    if (prefix === void 0) { prefix = ''; }
    var urlParams = new URLSearchParams(window.location.search);
    var entriesListStringified = (_b = (_a = Array.from(urlParams === null || urlParams === void 0 ? void 0 : urlParams.entries())) === null || _a === void 0 ? void 0 : _a.map(function (entry) { return "".concat(entry[0], "=").concat(entry[1]); })) === null || _b === void 0 ? void 0 : _b.join('&');
    if (!entriesListStringified)
        return '';
    return "".concat(prefix).concat(entriesListStringified);
};
var clearSessionStorageRVData = function () {
    sessionStorage.removeItem(sessionStorageKeys.recentlyViewedItems);
    sessionStorage.removeItem(sessionStorageKeys.recentlyViewedDatestamp);
};
var redirectToLogon = function (url) {
    if (url === void 0) { url = ''; }
    var redirectTo = '';
    var params = gatherAllParamsToString('&');
    if (url)
        redirectTo = "?redirect=".concat(url).concat(params);
    clearSessionStorageRVData();
    window.location.href = "".concat(SIGN_IN_HOST_PATH).concat(redirectTo !== '' ? redirectTo : '');
};
export var gotoLogonModule = function () {
    var redirectTo = window.location.pathname;
    redirectToLogon(redirectTo);
};
export var getFromUrlParams = function (key, mobileOnly) {
    if (mobileOnly === void 0) { mobileOnly = false; }
    var value = '';
    if (windowExists()) {
        var isMobile = window.innerWidth < 640;
        var urlParams = new URLSearchParams(window.location.search);
        if (!mobileOnly || (mobileOnly && isMobile))
            value = urlParams.get(key) || '';
    }
    return value;
};
export var removeFromUrlParams = function (key) {
    if (windowExists()) {
        var urlParams = new URLSearchParams(window.location.search);
        var size = urlParams.size;
        if (size === 0)
            return;
        urlParams.delete(key);
        var concat = size > 1 ? '?' : '';
        window.history.replaceState({}, '', "".concat(window.location.pathname).concat(concat).concat(urlParams.toString()));
    }
};
export var handleBasedOnUrlParams = function (key, queryValue, mobileOnly, callback) {
    if (mobileOnly === void 0) { mobileOnly = false; }
    /** Example Usage:
     *  handleBasedOnUrlParams('someKey', 'someVal', true, someFunction);
     */
    var valueFromParams = getFromUrlParams(key, mobileOnly);
    var isValueEqual = valueFromParams === queryValue;
    if (isValueEqual)
        callback();
};
export var useCopyToClipboard = function (text, setIsLoadingCopy, clickCta) {
    var _a;
    var _b = React.useState('inactive'), copyStatus = _b[0], setCopyStatus = _b[1];
    var navigatorExists = windowExists() && navigator && navigator.clipboard;
    var bridgeExists = windowExists() && !!((_a = window === null || window === void 0 ? void 0 : window.BenefitsJsBridge) === null || _a === void 0 ? void 0 : _a.copyToClipboard);
    var finalizeFailure = function () { return setCopyStatus('failed'); };
    var finalizeSuccess = function () {
        setCopyStatus('copied');
        setIsLoadingCopy(false);
        clickCta('pro xtra program details: personalized offer: copy discount code');
    };
    var copyWithDocument = function () {
        // Create and append temporary element
        var inputTMP = document.createElement('input');
        inputTMP.setAttribute('type', 'text');
        inputTMP.setAttribute('name', 'copyToClipboard__tmp');
        inputTMP.setAttribute('value', "".concat(text));
        document.body.appendChild(inputTMP);
        try {
            inputTMP.select();
            document.execCommand('copy');
            finalizeSuccess();
        }
        catch (err) {
            finalizeFailure();
        }
        inputTMP.remove();
    };
    var copyWithNavigator = function () {
        try {
            navigator.clipboard.writeText(text).then(function () { return finalizeSuccess(); }, function () { return finalizeFailure(); });
        }
        catch (err) {
            copyWithDocument();
        }
    };
    var copyWithBridge = function () {
        var _a;
        try {
            (_a = window === null || window === void 0 ? void 0 : window.BenefitsJsBridge) === null || _a === void 0 ? void 0 : _a.copyToClipboard(text);
            finalizeSuccess();
        }
        catch (err) {
            finalizeFailure();
        }
    };
    var copy = React.useCallback(function () {
        setIsLoadingCopy(true);
        if (bridgeExists)
            copyWithBridge();
        else if (navigatorExists)
            copyWithNavigator();
        else
            copyWithDocument();
    }, [text]);
    return [copyStatus, copy];
};
var getPreYearData = function (unclaimedPreYearPerks) {
    var preYearPerks = __spreadArray([], unclaimedPreYearPerks, true);
    for (var i = 0; i < unclaimedPreYearPerks.length; i += 1) {
        preYearPerks[i].tierPerks = [unclaimedPreYearPerks[i]];
    }
    return preYearPerks;
};
var getPreviousYearData = function (perkProgressData) {
    var data = __assign({}, perkProgressData);
    var preYearPerk = [];
    var unclaimedPreYearPerks = [];
    var tierPerks = [];
    tierPerks.length = 0;
    if (data && data.previousYearPerks) {
        unclaimedPreYearPerks = data.previousYearPerks.filter(function (perk) { return perk.perkStatus === 'UNCLAIMED'; });
        preYearPerk = getPreYearData(unclaimedPreYearPerks);
    }
    return preYearPerk;
};
export var hasUsedAllPerks = function (PerkInfo) {
    var currentYear = new Date().getFullYear();
    var currYearAccrualData = PerkInfo.accrualData.filter(function (accrualYear) { return accrualYear.year === currentYear; });
    return currYearAccrualData[0].finalTierPerkAchieved;
};
export var getYourPerkOptions = function (perkProgressData) {
    if (!perkProgressData)
        return null;
    var currentData = {};
    var data = __assign({}, perkProgressData);
    var preYearPerk = getPreviousYearData(perkProgressData);
    var lastItem = data.program.tiers.slice(-1).pop().maxThreshold;
    if (preYearPerk.length > 0) {
        currentData = { item: preYearPerk[0] };
    }
    else if (data && data.program && data.program.tiers) {
        currentData = {
            item: data.program.tiers.find(function (tier) {
                return (tier.tierPerks[0].earned &&
                    tier.tierPerks[0].perkStatus === 'UNCLAIMED') ||
                    (!tier.earned && data.currentTierId === tier.tierId) ||
                    data.nextTierId === tier.tierId ||
                    tier.maxThreshold === lastItem;
            }),
        };
    }
    return currentData;
};
function getCookie(name) {
    var cookieArray = document.cookie.split(';');
    for (var i = 0; i < cookieArray.length; i += 1) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name + '=') === 0) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return '';
}
export var getCookieProperty = function (cookieName, propertyName) {
    var _a;
    var cookieValue = getCookie(cookieName);
    if (cookieValue) {
        try {
            var decodedUrl = decodeURIComponent(cookieValue);
            var parts = decodedUrl.split(':;');
            var thdPersistCookie_1 = {};
            parts.forEach(function (part) {
                var _a = part.split('='), key = _a[0], value = _a[1];
                try {
                    thdPersistCookie_1[key] = JSON.parse(value);
                }
                catch (err) {
                    thdPersistCookie_1[key] = value;
                }
            });
            return parseInt((_a = thdPersistCookie_1[propertyName]) === null || _a === void 0 ? void 0 : _a.I1, 10);
        }
        catch (err) {
            console.error('Error parsing thdPersistCookie URL', err);
        }
    }
    return null;
};
export var getDaysUntil = function (dateString) {
    if (!dateString)
        return 0;
    var currentDate = new Date();
    var date = new Date(dateString);
    return Math.ceil((date.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
};
